/**
 * The names of events to be used in the `onEvent` callback
 * Between placeholders and plugins
 * @type {string}
 */
export const CARD = 'card';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/placeholder-events.js